export default "__VITE_ASSET__08bd917f__"